import { bsc } from '@reown/appkit/networks'
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'
import { createStorage, cookieStorage, http } from '@wagmi/core'
import { createPublicClient } from '@zircuit/zircuit-viem'
import { BATCH_OPTIONS } from 'constants/common'
import { zircuit, l1 } from 'constants/network'
import { env } from 'env.client'

export const wagmiAdapter = new WagmiAdapter({
  projectId: env.NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID,
  networks: [zircuit, l1, bsc],
  // *: https://wagmi.sh/react/guides/ssr
  ssr: true,
  storage: createStorage({
    key: `wagmi.store.zkr-bridge.${env.NEXT_PUBLIC_NETWORK}`,
    storage: cookieStorage,
  }),
  // @ts-expect-error: Mismatching types as `wagmi` uses `viem` instead of our custom fork `zkr-viem`.
  client({ chain }) {
    return createPublicClient({
      // @ts-expect-error: Mismatching types as `wagmi` uses `viem` instead of our custom fork `zkr-viem`.
      chain,
      // @ts-expect-error: Mismatching types as `wagmi` uses `viem` instead of our custom fork `zkr-viem`.
      transport: http(chain.rpcUrls.default.http[0], {
        batch: BATCH_OPTIONS,
      }),
    })
  },
})

export const { wagmiConfig } = wagmiAdapter
